/**
 * TutorTrainingScreen — « Ta formation » (route `tutor/formation`), à la place de
 * `tutor/training/TutorTrainingScreen.js` pour un tuteur dont l'espace est allumé.
 *
 * Patron A : la formation lue à l'ouverture (`useTutorTrainingData`) dans le réducteur
 * `tutorTraining`, mise en forme par `tutorTrainingViewModel` ; l'étape, les réponses et l'envoi du
 * quiz dans `useTutorTrainingState`.
 */
import React from "react"
import { useSelector } from "react-redux"

import { TutorTrainingPage } from "../../../../../../design-system/tutor"
import { tutorTrainingViewModel } from "../../../../view-models/tutor/Account/tutorTrainingViewModel"
import { useTutorTrainingData } from "./useTutorTrainingData"
import { useTutorTrainingState } from "./useTutorTrainingState"

export function TutorTrainingScreen() {
    const { fetch } = useTutorTrainingData()
    const vm = useSelector(tutorTrainingViewModel)
    const state = useTutorTrainingState(vm, fetch)

    return (
        <TutorTrainingPage
            video={vm.video}
            questions={vm.questions}
            neededCount={vm.neededCount}
            loading={vm.loading}
            error={vm.error}
            onRetry={fetch}
            {...state}
        />
    )
}
